<template>
  <ul class="articles scrollable" :class="{ desktop: $isDesktop }">
    <li
      v-for="(article, index) of specificArticlesData || generalArticlesData"
      :key="index"
    >
      <pu-link :path="article.url" @click="$emit('articleClicked')">
        <img
          v-if="!titlesOnly"
          loading="lazy"
          :src="article.imgUrl"
          :alt="article.title"
          class="picture"
          width="54"
          height="54"
        />
        <div>
          <span class="title">{{ article.title }}</span>
          <span v-if="!titlesOnly && article.snippet" class="snippet">{{
            article.snippet
          }}</span>
        </div>
      </pu-link>
    </li>
  </ul>
</template>

<script lang="ts">
import { Component, Vue, toNative, Prop } from '~/utility/pu-class-decorator'
import { filename } from 'pathe/utils'

// https://github.com/nuxt/nuxt/issues/14766#issuecomment-1397365205
const glob = import.meta.glob('~/assets/homepage/guides/*', { eager: true })
const guideImages = Object.fromEntries(
  Object.entries(glob).map(([key, value]) => [filename(key), value.default]),
)

@Component
class Articles extends Vue {
  @Prop({})
  specificArticlesData?: {
    title: string
    imgUrl: string
    url: string
    snippet: string
  }[]

  @Prop({ default: false })
  titlesOnly: boolean

  generalArticlesData = [
    {
      title: 'Camping guides',
      snippet:
        "We've been helping campers find their perfect pitch for more than 12 years now. But our experience goes far beyond that.",
      url: '/guides/',
      imgUrl: guideImages.guide,
    },
    {
      title: 'The ultimate NC500 itinerary',
      snippet:
        "The NC500 - also known as the North Coast 500 - is a 516-mile journey around Scotland's north coast and one of the Pitchup team's favourite UK road trips",
      url: '/camping-ideas/activities/road-trips/NC500/',
      imgUrl: guideImages.nc500,
    },
    {
      title: 'Camping ideas',
      snippet:
        "Are you a confident camper, or a newbie who's planning a first outdoor stay? Either way, this page is all about inspiring you to get",
      url: '/camping-ideas/',
      imgUrl: guideImages['camping-ideas'],
    },
    {
      title: 'Camping with a dog',
      snippet:
        "So you want to take your dog on a camping break? First things first - you'll need to pick a campsite that welcomes dogs",
      url: '/guides/camping/types-of-camping/camping-with-a-dog/',
      imgUrl: guideImages.dogs,
    },
    {
      title: 'Best campsites UK',
      snippet:
        'Short on time? Our team has hand-picked the best campsites for your next camping trip to help you whittle down where to go',
      url: '/camping-ideas/best-campsites/',
      imgUrl: guideImages['best-campsites-uk'],
    },
    {
      title: "Wild camping: a beginner's guide",
      snippet:
        "Wild camping can be an incredibly peaceful and even spiritual experience, but it takes a bit of planning to make sure you're doing it in a safe and legal way",
      url: '/guides/camping/types-of-camping/wild-camping/',
      imgUrl: guideImages.wild,
    },
    {
      title: 'Campfires',
      snippet:
        'A campfire is one of the very best bits about going camping. It is the focal point of your camping pitch, you can cook on it',
      url: '/guides/camping/campfires/',
      imgUrl: guideImages.campfires,
    },
    {
      title: 'National Parks',
      snippet:
        "From The Broads wetlands to the granite tors of Dartmoor, the UK's incredible national parks are our outdoor playgrounds.",
      url: '/area-guides/national-parks/',
      imgUrl: guideImages['national-parks'],
    },
    {
      title: 'Review Awards',
      snippet:
        "Pitchup.com's review awards are based on nearly 200,000 customer reviews from 2024. Here's our shortlist of the top rated campsites.",
      url: '/review-awards/',
      imgUrl: guideImages['review-awards'],
    },
  ]
}

export default toNative(Articles)
</script>
<style scoped>
ul {
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: repeat(2, 83vw);
  column-gap: 1em;
  row-gap: 1em;
}

a {
  display: flex;
  align-items: center;
  text-decoration: none;
  line-height: 1.2;
}

a .title {
  font-size: var(--body);
  color: var(--colour-wcag-blue);
  font-weight: bold;
  display: block;
}

a .snippet {
  font-size: var(--small);
  color: var(--colour-text-light);
  font-weight: normal;
  display: block;
  margin-top: 0.2em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.picture {
  width: 3em;
  height: 3em;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 0.4em;
  margin-right: 0.5em;
}

/* desktop & tablet */
ul.articles.desktop.scrollable {
  column-gap: 4em;
  grid-template-columns: repeat(auto-fit, minmax(30em, 1fr));
  overflow: unset;
  padding: 3em 5em;
  row-gap: 3em;
}

a {
  align-items: flex-start;
}

.desktop .picture {
  border-radius: 1em;
  height: 7.5em;
  margin-right: 2em;
  width: 7.5em;
}

.desktop a .title {
  font-size: 1.4em;
}

.desktop a .snippet {
  -webkit-line-clamp: 3;
  font-size: 1.3em;
  line-clamp: 3;
  line-height: 1.3;
  margin-top: 0.4em;
}
</style>
